<script setup lang="ts">
import { useIntervalFn } from '@vueuse/core';
import { storeToRefs } from 'pinia';

const { ongoingNetworkCalls } = storeToRefs(useMiscStore());
const progress = ref(0);
let hideAt: number | undefined = undefined;

useIntervalFn(() => {
    if (progress.value < 1) {
        if (ongoingNetworkCalls.value > 0) {
            progress.value = Math.min(progress.value + 0.1 / ongoingNetworkCalls.value, 1);
        } else if (progress.value > 0) {
            progress.value = 1;
            hideAt = Date.now() + 1000;
        }
        return;
    }
    if (ongoingNetworkCalls.value > 0) {
        return;
    }
    if (hideAt === undefined) {
        progress.value = 0;
        return;
    }
    if (hideAt < Date.now()) {
        progress.value = 0;
        hideAt = undefined;
        return;
    }
}, 100);
</script>

<template>
    <div v-show="progress > 0" class="parent">
        <div
            class="child"
            :style="{
                width: progress * 100 + '%',
            }"
        ></div>
    </div>
</template>

<style scoped>
.parent {
    width: 100%;
    height: 4px;
    padding: 1px;
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 9999999;
}

.child {
    height: 2px;
    background: #654ea3; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #eaafc8, #654ea3); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(
        to right,
        #eaafc8,
        #654ea3
    ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    box-shadow: 0px 0px 10px 2px #654ea3;
    width: 0%;
    transition: width 0.3s ease-in-out;
}
</style>
